module.exports = __webpack_public_path__ + "static/media/maintenance4.899c608e.jpg";